export const STATUSES_LOADED = "statuses/loaded"
export const STATUSES_ADDED = "statuses/statesAdded"
export const STATUS_UPDATED = "statuses/stateUpdated"
export const STATUS_DELETED = "statuses/stateDeleted"
export const STATUSES_DELETED = "statuses/statesDeleted"